/* ReliefYou ticker (sections/ry-ticker.liquid). Styles: assets/ry-ticker.css.
   - Pause toggle (WCAG 2.2.2): aria-pressed. One "Pause motion" state per visit, shared with the photo reels
     (sessionStorage key ry-reel-paused, same as assets/ry-reel.js): pressing it pauses or plays every ticker
     and reel on the page.
   - Pauses while off-screen (class is-offscreen), to save battery.
   The animation itself is CSS and only runs once this element is defined. */
(() => {
  if (customElements.get('ry-ticker')) return;

  const STORAGE_KEY = 'ry-reel-paused';

  const readPaused = () => {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const writePaused = (paused) => {
    try {
      if (paused) {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } else {
        window.sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      /* Storage blocked: the toggle still works for this page. */
    }
  };

  class RyTicker extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-ry-ticker-toggle]');
      this.setPaused(readPaused());

      this.onToggle = () => {
        const paused = this.toggle.getAttribute('aria-pressed') !== 'true';
        writePaused(paused);
        document.querySelectorAll('ry-ticker, ry-reel').forEach((element) => {
          if (typeof element.setPaused === 'function') element.setPaused(paused);
        });
      };
      if (this.toggle) this.toggle.addEventListener('click', this.onToggle);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.classList.toggle('is-offscreen', !entry.isIntersecting));
        });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
    }

    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
      if (this.toggle) this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }
  }

  customElements.define('ry-ticker', RyTicker);
})();
